"use client";

import {enableStaticRendering} from "mobx-react-lite/es/staticRendering";
import {StoreContext} from "@soprisapps/components/stores/StoreContext";
import {PropsWithChildren, useEffect, useMemo} from "react";
import {hydrateStores} from "./storeUtils";
import {ExecutionEnvironment} from "./InterfaceStore";
import allStoresSingleton, {loadStores} from "./StoreLoader";
import {FeatureFlagsContext} from "../utils/featureFlags/FeatureFlagContext";

const ClientTransitionWrapper = (props: PropsWithChildren<{
    initialLookupData: SoprisAppsProps["pageProps"]
}>) => {
    const allStores = useMemo(() => {
        let stores;
        if (ExecutionEnvironment.canUseDOM) {
            stores = allStoresSingleton;
        } else {
            enableStaticRendering(true);
            stores = loadStores();
        }
        if (!stores.isHydrated) {
            // this should always be the case on the server, but only once on the client
            hydrateStores(stores, props.initialLookupData);
        }
        return stores;
    }, [])

    useEffect(() => {
        if (props.initialLookupData.currentFullUrl !== allStores.interfaceStore.currentFullUrl) {
            // this should run on page transitions but not on initial load. On initial load, we want hydration to occur
            // synchronously (above) so that the new state is immediately reflected in the UI.
            hydrateStores(allStores, props.initialLookupData);
        }
    }, [props.initialLookupData.currentFullUrl]);

    return <FeatureFlagsContext.Provider value={props.initialLookupData.featureFlags}>
        <StoreContext.Provider value={allStores}>
            {props.children}
        </StoreContext.Provider>
    </FeatureFlagsContext.Provider>
};

export default ClientTransitionWrapper;
